import * as React from 'react';
import { PointerImage } from './PointerImage';
import { useMousePosition } from '@hooks/useMousePosition';
import { streamPointerPosition } from '@services';
import { isValidNumber } from '@utils/validateInputs';
import { PING_INTERVALS } from '@constants';

export const Pointer = ({ slideRef, showPointer, dispatch }) => {
    const position = useMousePosition(slideRef, showPointer);

    React.useEffect(() => {
        const { pointerMs } = PING_INTERVALS;
        
        const timer = setTimeout(async () => {
            if (showPointer) {
                const { x, y } = position;

                if (isValidNumber(x) && isValidNumber(y)) {
                    await streamPointerPosition({ x, y });
                } else {
                    console.log(`Not streaming invalid pointer position - x: ${x}, y: ${y}`);
                }
            }
        }, pointerMs);

        return () => clearTimeout(timer);

    }, [position]);

    if (!position) return null;

    return (
        <PointerImage
            dispatch={dispatch}
            showPointer={showPointer}
            slideRef={slideRef}
            position={position} />
    );
};

export default Pointer;
